import axios from 'axios';
import { message } from 'antd';

export const basicUrl = window.g.baseURL
const service = axios.create({
  baseURL: basicUrl,
  timeout: window.g.requestOutTime * 1000
})

// 文档中的统一设置post请求头。下面会说到post请求的几种'Content-Type'
// instance.defaults.headers.post['Content-Type'] = 'application/json'

let httpCode = {        //这里我简单列出一些常见的http状态码信息，可以自己去调整配置
  400: '请求参数错误',
  401: '权限不足, 请重新登录',
  403: '服务器拒绝本次访问',
  404: '请求资源未找到',
  500: '内部服务器错误',
  501: '服务器不支持该请求中使用的方法',
  502: '网关错误',
  504: '网关超时'
}


// 请求拦截器
service.interceptors.request.use(config => {
  let token
  if (window.location.href.indexOf('isQHDBI') > -1 || window.location.href.indexOf('StatisticsTableOWS') > -1 || window.location.href.indexOf('customSearchOWS') > -1)//判断是不是秦皇岛BI大屏过来的请求
  {
    token = 'null';
  } else {
    token = window.localStorage.getItem('token') || -1;
  }
  //在每次的请求中添加token
  config.data = Object.assign({}, config.data, {
    Token: token,
  })
  //设置请求头
  // config.headers = {
  //   'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
  // }
  // config.data = QS.stringify(config.data)
  return config
}, error => {
  return error;
})

// 响应拦截器
service.interceptors.response.use(response => {
  //记录每次请求的数据内容
  localStorage.setItem('currentRequestDetailData', JSON.stringify(response.data) + JSON.stringify(response.config.data));
  //根据返回不同的状态码做不同的事情
  if (response.data.Status) {
    switch (response.data.Status) {
      case 1:
        return response.data;
      case 5:
        //未登录处理方法
        localStorage.removeItem("token");
        window.location.href = '/403';
        break;
      case 403:
        //token过期处理方法
        break;
      default:
        return response.data
    }
  } else {
    return response.data
  }
}, error => {
  //请求超时、跨域、url
  localStorage.setItem('currentRequestDetailData', JSON.stringify(error));
  if (error.response) {
    // 根据请求失败的http状态码去给用户相应的提示
    let tips = error.response.status in httpCode ? httpCode[error.response.status] : error.response.data.message
    message.error(tips)
  }
})

export default service;